import { GetGroupsFilterKey } from 'types';

export const groupsFilterFields: Record<GetGroupsFilterKey, GetGroupsFilterKey> = {
    toYear: 'toYear',
    fromYear: 'fromYear',
};
